import React, { useState, useEffect } from "react";
import logo_transparent from "../../assets/logo-transparent.png";

const Header = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".header");
      header?.classList.toggle("shadow-md", window.scrollY >= 80);

      // Close mobile menu on scroll if it's open
      if (isMenuOpen) {
        setMenuOpen(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isMenuOpen]);

  const handleNavClick = () => {
    setMenuOpen(false); // Close menu on nav click in mobile view
  };

  const NavLink = ({ href, label }) => (
    <li>
      <a
        href={href}
        onClick={handleNavClick}
        className="text-[var(--title-color)] transition duration-300 font-medium pl-2"
      >
        {label}
      </a>
    </li>
  );

  const renderDesktopNav = () => (
    <ul className="hidden md:flex flex-row items-center gap-4">
      {navItems.map(({ href, label }) => (
        <NavLink key={href} href={href} label={label} />
      ))}
    </ul>
  );

  const renderMobileNav = () =>
    isMenuOpen && (
      <div className="fixed top-16 left-0 py-4 w-screen bg-[var(--body-color)] shadow-lg z-40 md:hidden">
        <ul className="flex flex-col items-center gap-4">
          {navItems.map(({ href, label }) => (
            <NavLink key={href} href={href} label={label} />
          ))}
        </ul>
      </div>
    );

  const navItems = [
    { href: "#about", label: "About Me" },
    { href: "#skills", label: "Skills" },
    { href: "#portfolio", label: "Recent Works" },
    // { href: "#experiences", label: "Employment Records" },
    { href: "#accreditations", label: "Accreditations" },
    { href: "#achievement", label: "Achievements" },
  ];

  return (
    <header className="header w-screen fixed z-50 bg-white">
      <nav className="max-w-5xl mx-auto px-4 md:px-0 md:py-2 flex items-center justify-between">
        <a href="/">
          <img
            src={logo_transparent}
            alt="logo"
            className="size-16 object-contain"
          />
        </a>
        {renderDesktopNav()}
        <div
          className="text-xl text-[var(--title-color)] cursor-pointer md:hidden ml-auto"
          onClick={() => setMenuOpen(!isMenuOpen)}
        >
          <i className={`uil ${isMenuOpen ? "uil-times" : "uil-bars"}`}></i>
        </div>
        {renderMobileNav()}
      </nav>
    </header>
  );
};

export default Header;
